<template>
  <v-container fluid class="pa-0">
    <v-row>
      <v-col align-self="center" cols="auto">
        <p class="font-168EEA headline">
          <slot name="title-focus"></slot>
        </p>
        <p class="font-168EEA title">
          <slot name="text-focus"></slot>
        </p>
        <p class="body-2">
          <slot name="normal-text"></slot>
        </p>
      </v-col>
      <v-spacer></v-spacer>
      <v-row dense justify="end" class="pt-3">
        <v-spacer />
        <v-col cols="auto">
          <v-btn
            v-if="backButton"
            color="#29284c"
            small
            outlined
            width="120"
            class="text-capitalize"
            @click="backAction"
            >Previous Step</v-btn
          >
        </v-col>
        <v-col cols="auto">
          <v-btn
            color="#FF347C"
            small
            width="120"
            v-if="button"
            depressed
            :disabled="!enabled"
            class="white--text text-capitalize mr-2"
            @click="$emit('next-exercise')"
          >
            <slot name="buttonText">Next Exercise</slot>
          </v-btn>
        </v-col>
      </v-row>
    </v-row>
  </v-container>
</template>
<script>
export default {
  props: {
    enabled: {
      required: false,
      default: true,
      type: Boolean,
    },
    button: {
      required: false,
      default: true,
      type: Boolean,
    },
    backAction: {
      required: false,
      type: Function,
      default: () => {},
    },
    backButton: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style scoped>
.font-168EEA {
  color: #168eea;
  font-size: 18px;
}
p {
  margin-bottom: 0px;
}
</style>
